module["exports"] = ["Gruppen", "AB", "HB", "Group", "Investment", "Kommanditbolag", "Aktiebolag"];